module.exports = __webpack_public_path__ + "static/media/eduskills.ca613fa0.jpg";